import { SessionRepository } from './repository/session-repository';
import { AreaRepository } from './repository/area-repository';
import { ActivityRepository } from './repository/activity-repository';
import { UserRepository } from './repository/user-repository';
import { SchoolRepository } from './repository/school-repository';
import { SearchRepository } from './repository/search-repository';
import { EventRepository } from './repository/event-repository';
import { ReportRepository } from './repository/report-repository';
import { SettingsRepository } from './repository/settings-repository';

const sessionRepository = ()=> SessionRepository;
const areaRepository = ()=> AreaRepository;
const activityRepository = ()=> ActivityRepository;
const userRepository = ()=> UserRepository;
const schoolRepository = ()=> SchoolRepository;
const searchRepository = ()=> SearchRepository;
const eventRepository = ()=> EventRepository;
const reportRepository = ()=> ReportRepository;
const settingsRepository = ()=> SettingsRepository;

export default {
  session: sessionRepository,
  area: areaRepository,
  activities: activityRepository,
  users: userRepository,
  school: schoolRepository,
  search: searchRepository,
  events: eventRepository,
  report: reportRepository,
  settings: settingsRepository
};
